import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";
import parseToTimestamp from "shared/utils/parseToTimestamp";

export const fetchAppDrawer = createAsyncThunk(
    'contract/fetchAppDrawer',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getRequest({}, 'dms-hr', 'getCuratorData', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { PersonalAccountPartsVisibility: data.Curator.PersonalAccountPartsVisibility};
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);